import { Download, CheckCircle2 } from "lucide-react";
import { Logo } from "../components/Logo";

export default function DownloadPage() {
  return (
    <section data-testid="download-page" className="flex min-h-screen flex-col items-center justify-center bg-limestone px-6 py-24 text-center">
      <Logo />
      <h1 className="mt-10 font-serif text-3xl tracking-tight text-forest md:text-4xl">
        Download your website
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-charcoal/80 md:text-base">
        One tap below saves your finished website to your iPad as a single ZIP file. It is the complete,
        ready-to-publish website — not source code — and includes the step-by-step Netlify publishing guide.
      </p>
      <a
        href="/cotswold-drone-mapping-website.zip"
        download="cotswold-drone-mapping-website.zip"
        data-testid="download-zip-button"
        className="mt-8 inline-flex items-center gap-3 rounded-full bg-forest px-10 py-5 text-sm font-semibold uppercase tracking-[0.15em] text-limestone transition-colors hover:bg-forest-deep"
      >
        <Download className="h-5 w-5" />
        Download website (ZIP)
      </a>
      <div className="mt-12 max-w-md space-y-3 text-left">
        {[
          "Tap the green button above — Safari saves the ZIP to the Files app (Downloads folder).",
          "In the Files app, tap the ZIP once — your iPad unzips it into a folder automatically.",
          "That folder is what you publish: follow the HOSTING-GUIDE inside it, or drag the folder onto app.netlify.com/drop.",
        ].map((s, i) => (
          <div key={s} className="flex items-start gap-3 text-sm leading-relaxed text-charcoal/80">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-ochre" strokeWidth={1.75} />
            <p><span className="font-semibold text-forest">Step {i + 1}.</span> {s}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
